module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/isologotipo_b_positivo-dc70dc181ba803a624045ea66b36b056.svg";